export type Message = {
  flag: ErrorTypeEnum
  message: string
}
export enum ErrorTypeEnum {
  Unknown = 'unknown',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}
